import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useInventoryStore } from '../../store/inventoryStore'
import { recordOutTransaction } from '../../utils/recordOutTransaction'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export function useRecordOutTransactionMutation(onSuccess?: () => void) {
  const addTransaction = useInventoryStore((state) => state.addTransaction)
  const updateInventoryStock = useInventoryStore(
    (state) => state.updateInventoryStock,
  )

  return useMutation({
    mutationFn: recordOutTransaction,
    onSuccess: ({ message, transaction, stock }) => {
      addTransaction(transaction)
      updateInventoryStock(stock)
      toast.success(message || 'Out transaction recorded successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(
        error,
        'An error occurred while recording out transaction.',
      )
    },
  })
}
